import type { InspirationJournalEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const InspirationIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<path d="M8 1.5a4 4 0 0 0-2.4 7.2c.3.25.5.6.55 1l.1.8h3.5l.1-.8c.05-.4.25-.75.55-1A4 4 0 0 0 8 1.5Z" />
		<path d="M6.5 13.5h3M7 15h2" />
	</svg>
)

export function InspirationEventRow({
	event,
}: {
	event: InspirationJournalEvent
}) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const copy =
		event.type === "inspiration.created"
			? t.journal.events.inspirationCreated
			: t.journal.events.inspirationDeleted
	return (
		<JournalRowShell
			icon={<InspirationIcon />}
			headline={copy.label}
			actor={actor}
			iso={event.createdAt}
			eventType={event.type}
			aria={interpolate(copy.aria, { actor })}
		/>
	)
}
